import { Box } from "@mui/material";
import React from "react";
import { Colors } from "../../Constants/colors";
import { borderLeft } from "@mui/system";

interface Props {
  onClick: () => unknown;
  isClicked: boolean;
}
export const DropdownAnchor = ({ onClick, isClicked }: Props) => {
  return (
    <Box
      style={{
        transform: isClicked ? "rotate(270deg)" : "rotate(90deg)",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <svg
        width="10"
        height="10"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.589996 10.59L5.17 6L0.589996 1.41L2 0L8 6L2 12L0.589996 10.59Z"
          fill={Colors.AshRose}
        />
      </svg>
    </Box>
  );
};
